// extracted by mini-css-extract-plugin
export default {"container":"dP_d","imageContainer":"dP_gd","textContainer":"dP_dz","title":"dP_c0","description":"dP_cM"};